namespace $ {
	$.$hyoo_crus_yard.masters = [
		'https://crus.hyoo.ru/',
		'https://i-love-crus.ru/',
		'https://crus.xedth.ru/',
		'https://crus.87-120-36-150.ip.hyoo.ru/',
	]
}
